import type { DataWarehouseEndpointSuffix } from "instant-config";
import { getBooleanQueryParam } from "utils";

const canSendCache = new Map<DataWarehouseEndpointSuffix, boolean>();

/**
 * Uses the ICBM parameter to determine sampling
 *
 *  * (recommended): To override this setting, you can add the query parameter ?force_tracking=true
 * This will apply for all types of tracking sampling (Beacon and Prometheus)
 *
 * Alternateyl, you can also override the icbm data directly, e.g.:
 * &icbm__odysseyBeaconSenderTrafficLimiter={"adengloadtimes":100}
 *
 */
export function shouldSendToEndpoint(
  endpoint: DataWarehouseEndpointSuffix,
): boolean {
  /**
   * adengbidders currently implements a more complex sampling strategy, which is
   * hardcoded into the AuctionTracking plugin. If data arrives in the fandomTrack
   * for adengbidders, it means it should be sent.
   */
  if (endpoint == "adengbidders") {
    return true;
  }

  if (getBooleanQueryParam("force_tracking")) {
    return true;
  }

  const cachedValue = canSendCache.get(endpoint);

  if (cachedValue !== undefined) {
    return cachedValue;
  }

  const thresholds = window.icbm?.config?.odysseyBeaconSenderTrafficLimiter;

  if (thresholds?.[endpoint] === undefined) {
    canSendCache.set(endpoint, true);
    return true;
  }

  const isAllowed = Math.random() * 100 < thresholds[endpoint];

  canSendCache.set(endpoint, isAllowed);

  return isAllowed;
}
